var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGerviceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.828,
    height: 82.83,
    viewBox: "0 0 82.828 82.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GerviceLogoMain",
    transform: "translate(-83.836 -207.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_27",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 27",
    transform: "translate(85.25 208.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_294",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 294",
    d: "M288.8,490.58l-26.87,26.87-8.238-8.24",
    transform: "translate(-221.928 -437.449)",
    fill: "none",
    stroke: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_295",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 295",
    d: "M374.29,285.72l25.5,25.5-6.867,6.869",
    transform: "translate(-319.788 -271.218)",
    fill: "none",
    stroke: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_296",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 296",
    d: "M173.1,232.245l23.435-23.435,8.24,8.24",
    transform: "translate(-156.535 -208.81)",
    fill: "none",
    stroke: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_297",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 297",
    d: "M110.748,402.111l-25.5-25.5,10.3-10.3",
    transform: "translate(-85.25 -336.611)",
    fill: "none",
    stroke: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_298",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 298",
    d: "M191.32,527.01",
    transform: "translate(-171.319 -467.009)",
    fill: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_299",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 299",
    d: "M403.45,314.88",
    transform: "translate(-343.449 -294.879)",
    fill: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_300",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 300",
    d: "M220.47,556.17",
    transform: "translate(-194.972 -490.67)",
    fill: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_301",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 301",
    d: "M374.29,285.72",
    transform: "translate(-319.788 -271.218)",
    fill: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_5",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 5",
    x1: 54.091,
    transform: "translate(98.204 248.812)",
    fill: "none",
    stroke: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_302",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 302",
    d: "M297.38,253.15",
    transform: "translate(-172.13 -35.979)",
    stroke: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_303",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 303",
    d: "M297.38,208.81",
    transform: "translate(-172.13)",
    stroke: "#FFFF",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_28",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 28",
    transform: "translate(105.411 251.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_304",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 304",
    d: "M195.383,444.5a3.394,3.394,0,0,1-1.839-.447,2.641,2.641,0,0,1-1.041-1.239,4.689,4.689,0,0,1-.334-1.833,6.451,6.451,0,0,1,.305-2.076,2.8,2.8,0,0,1,1.007-1.409,3.153,3.153,0,0,1,1.889-.509,7.9,7.9,0,0,1,1.114.074,6.519,6.519,0,0,1,.933.2v.294a7.207,7.207,0,0,0-2-.283,2.94,2.94,0,0,0-1.776.475,2.5,2.5,0,0,0-.905,1.307,6.472,6.472,0,0,0-.26,1.929,3.66,3.66,0,0,0,.7,2.37,2.76,2.76,0,0,0,2.274.866,6.3,6.3,0,0,0,1.154-.107,5.547,5.547,0,0,0,.984-.266V440.9h-2.195v-.294h2.512v3.36a3.578,3.578,0,0,1-.888.356A6.086,6.086,0,0,1,195.383,444.5Z",
    transform: "translate(-192.17 -436.99)",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_305",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 305",
    d: "M230.99,444.876V437.59h4.616v.283h-4.3v3.213h3.9v.283h-3.9v3.224h4.3v.283Z",
    transform: "translate(-223.67 -437.477)",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_306",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 306",
    d: "M263.27,444.876V437.59h2.9a2.013,2.013,0,0,1,1.6.56,2.607,2.607,0,0,1,.073,2.925,1.85,1.85,0,0,1-1.25.656.887.887,0,0,1,.413.3,3.022,3.022,0,0,1,.266.492l1.007,2.353h-.317l-1-2.285a1.75,1.75,0,0,0-.277-.47.871.871,0,0,0-.43-.255,2.958,2.958,0,0,0-.775-.079h-1.889v3.089Zm.317-3.371h2.466a2.089,2.089,0,0,0,1.38-.424,1.739,1.739,0,0,0,.509-1.409,1.566,1.566,0,0,0-1.742-1.8h-2.613Z",
    transform: "translate(-249.863 -437.477)",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_307",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 307",
    d: "M295.839,444.876l-2.749-7.286h.328l2.67,7.105,2.67-7.105h.328l-2.738,7.286Z",
    transform: "translate(-274.06 -437.477)",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_308",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 308",
    d: "M332.39,444.876V437.59h.317v7.286Z",
    transform: "translate(-305.95 -437.477)",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_309",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 309",
    d: "M345.672,444.5a3.394,3.394,0,0,1-1.839-.447,2.609,2.609,0,0,1-1.035-1.239,4.758,4.758,0,0,1-.328-1.833,6.567,6.567,0,0,1,.3-2.076,2.766,2.766,0,0,1,1-1.409,3.173,3.173,0,0,1,1.9-.509,7.348,7.348,0,0,1,1.115.079,4.627,4.627,0,0,1,.933.238v.294a4.889,4.889,0,0,0-.933-.243,6.638,6.638,0,0,0-1.081-.085,2.913,2.913,0,0,0-1.771.475,2.509,2.509,0,0,0-.9,1.307,6.468,6.468,0,0,0-.26,1.929,3.681,3.681,0,0,0,.7,2.37,2.743,2.743,0,0,0,2.268.866,7.522,7.522,0,0,0,1.03-.073,5.567,5.567,0,0,0,.95-.209v.294a6.532,6.532,0,0,1-.933.2A7.905,7.905,0,0,1,345.672,444.5Z",
    transform: "translate(-314.129 -436.99)",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_310",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 310",
    d: "M378.71,444.876V437.59h4.616v.283h-4.3v3.213h3.9v.283h-3.9v3.224h4.3v.283Z",
    transform: "translate(-343.536 -437.477)",
    fill: "#FFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_30",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 30",
    transform: "translate(118.585 227.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_29",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_311",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 311",
    d: "M275.177,312.825a2.021,2.021,0,0,0-.373.17,2.865,2.865,0,0,0-.339.217,1.14,1.14,0,0,1-.749.238,5.822,5.822,0,0,1-1.011-.081c-.354-.058-.7-.126-1.037-.2a3.833,3.833,0,0,0-.818-.115,5.126,5.126,0,0,0-1.529.23v-.015a.22.22,0,0,1-.1-.023.15.15,0,0,1-.03-.015.326.326,0,0,1-.034.021.675.675,0,0,1-.132.043s0,0,0,0h0a.117.117,0,0,1-.011.015v.066c-.041.009-1.071.62-1.575.854-.025.011,1.437-.7,1.4-.684-.008,0-.158.085-.166.087s-.373.151-.145.145h0c-.026.009-.432.5-.458.511-.006,0,.956-.92.937-.915l-1.9,1.032c-.011.008,1.776-.709,1.763-.7.047-.028-1.752.692-1.763.7s.656-.074.645-.064c-.026.023.777-.579.749-.556-.066.053-.172-.041-.241.006-.053.036-.109.064-.162.1l-.019.015s-.006.006-.009.008l-.028.028c-.023.025-.021.026,0,0a.347.347,0,0,1-.119.106.263.263,0,0,1-.173.059c-.1,0-.066.1-.111.04l-.206.085v-4.8a3.436,3.436,0,0,1,.768.17c.255.087.522.183.807.292v2.531a.281.281,0,0,1,.211,0c0-.089-.006-.175-.006-.264a.271.271,0,0,1,.108-.217l.011-1.953a3.435,3.435,0,0,0,1.337.115,5.553,5.553,0,0,0,1.324-.319h0a.159.159,0,0,1,.032-.013.323.323,0,0,1,.045-.017,4.926,4.926,0,0,0,1.448-.773s0,0,.006,0l.385-.364a1.17,1.17,0,0,0,.23-.279.712.712,0,0,0,.109-.258c.01-.068-.021-.1-.089-.1a.887.887,0,0,0-.36.162,3.979,3.979,0,0,1-1.616.6,3.465,3.465,0,0,1-1.71-.17,2.712,2.712,0,0,1-.618-.313,1.591,1.591,0,0,0-.522-.245v-1.086c0-.1-.053-.149-.156-.149s-.17.049-.17.149v1.045h-.281a6.128,6.128,0,0,0-.654.115c-.213.049-.428.111-.641.183v-2.308a.179.179,0,0,0-.047-.122.149.149,0,0,0-.115-.055c-.109,0-.162.058-.162.177V308.4a5.818,5.818,0,0,0-.875.407c-.285.162-.558.336-.822.517a9.452,9.452,0,0,0-1.4,1.229,7.948,7.948,0,0,0-1.107,1.486,6.631,6.631,0,0,0-.686,1.7,5.8,5.8,0,0,0-.157,1.846,5.871,5.871,0,0,0,.468,1.955,6.012,6.012,0,0,0,1.06,1.65,6.335,6.335,0,0,0,1.527,1.229,5.63,5.63,0,0,0,1.874.679.493.493,0,0,0,.123.013v1.684c0,.117.055.177.162.177a.155.155,0,0,0,.115-.047.174.174,0,0,0,.047-.128v-1.642a4.256,4.256,0,0,0,.8.06,4.7,4.7,0,0,0,.775-.075,9.758,9.758,0,0,1-.064,1.263,6.8,6.8,0,0,1-.134.747,2.433,2.433,0,0,1-.134.407.584.584,0,0,0-.064.23.54.54,0,0,0,.172.4.55.55,0,0,0,.4.17.511.511,0,0,0,.377-.17.559.559,0,0,0,.166-.4.529.529,0,0,0-.058-.217,3,3,0,0,1-.138-.394,5.041,5.041,0,0,1-.138-.76,11.5,11.5,0,0,1-.059-1.316,5.739,5.739,0,0,0,1.7-.564,8.145,8.145,0,0,0,1.527-1.026c.009.317.019.622.026.916s.013.586.013.875l-1.48,1.493c-.236.245-.355.405-.36.483s.049.1.162.075a1.548,1.548,0,0,0,.434-.2,2.972,2.972,0,0,0,.468-.353c.164-.162.353-.332.571-.509s.432-.36.645-.551a7.252,7.252,0,0,0,.59-.59,2.277,2.277,0,0,0,.407-.632,2.15,2.15,0,0,0,.143-.686,5.725,5.725,0,0,0-.013-.8c-.023-.275-.049-.547-.081-.815a6.126,6.126,0,0,1-.047-.726c-.009-.371-.008-.747.007-1.128a7.345,7.345,0,0,1,.128-1.12,5.171,5.171,0,0,1,.332-1.065,3.631,3.631,0,0,1,.619-.964c.172-.19.249-.309.23-.36S275.281,312.793,275.177,312.825Zm-8.072,1.582-.353.353a1.029,1.029,0,0,0-.243.285.776.776,0,0,0-.109.264c-.009.068.021.1.089.1a.831.831,0,0,0,.36-.177l.258-.149v4.277a4.887,4.887,0,0,1-1.222-.666,5.874,5.874,0,0,1-1.06-1.026,6,6,0,0,1-.767-1.243,5.9,5.9,0,0,1-.441-1.4,5.808,5.808,0,0,1-.081-1.48,6.086,6.086,0,0,1,.509-1.921,4.07,4.07,0,0,1,1.229-1.569,2.91,2.91,0,0,1,.93-.543,2.426,2.426,0,0,1,.9-.123v5.016Zm.326.5a3.944,3.944,0,0,1,.794-.3,4.678,4.678,0,0,1,.781-.123v1.642a2.847,2.847,0,0,1-.749.713,1.76,1.76,0,0,1-.828.279v-2.214Zm1.575,4.955a6.313,6.313,0,0,1-1.575-.366v-.76a3.023,3.023,0,0,1,.754-.713,2.154,2.154,0,0,1,.82-.306Zm0-2.47a2.449,2.449,0,0,0-.82.245,2.714,2.714,0,0,0-.754.585v-.76a2.655,2.655,0,0,0,.832-.245,2.523,2.523,0,0,0,.764-.585Zm4-1.935a7.571,7.571,0,0,0-.285,1.094,9.382,9.382,0,0,0-.136,1.133q-.034.577-.034,1.147a3.3,3.3,0,0,1-1.459.869,5.468,5.468,0,0,1-1.759.2v-5.417a9.836,9.836,0,0,1,1.335.094,14.158,14.158,0,0,0,1.458.123,3.559,3.559,0,0,0,.722-.068,2.792,2.792,0,0,0,.641-.217A5.383,5.383,0,0,0,273.005,315.459Z",
    transform: "translate(-262.036 -305.78)",
    fill: "#FFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_26",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 26",
    width: 0.315,
    height: 1.593,
    transform: "translate(6.97 6.074)",
    fill: "#FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_312",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 312",
    d: "M315.29,326.8",
    transform: "translate(-305.248 -322.836)",
    fill: "#FFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_27",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 27",
    width: 0.198,
    height: 0.104,
    transform: "translate(124.564 235.541)",
    fill: "#FFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerviceLogo);
export default __webpack_public_path__ + "static/media/GerviceLogo.5a8afa10faaa37999023698cce3335b2.svg";
export { ForwardRef as ReactComponent };